<ion-button
  expand="block"
  (click)="createJob()"
  [disabled]="accountsCallInProgress"
>
  {{ buttonText }}
</ion-button>
